import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import siteMessage from "@insite/client-framework/SiteMessage";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ApiResultModel, getOrderStatusService } from "@WhiteCap/Store/Service/CustomOrderStatusPageService";

// Load custom order status page data
export interface CustomOrderStatusApiParameter extends ApiParameter {
    orderId: string;
    q: string | null;
    onSuccess?: () => void;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<CustomOrderStatusApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/OrderStatus/BeginLoadData",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    let queryString = "";
    if(props.apiParameter.q) {
        queryString = `&q=${props.apiParameter.q}`
    }

    const result = await getOrderStatusService(`${props.apiParameter.orderId}${queryString}`);
    if (result.successful && result.result) {
        props.apiResult = result.result;
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/OrderStatus/LoadDataError",
            message: result.statusCode === 504 || result.statusCode === 524 ? siteMessage("OSN_Load_Order_Status_Page_API_Timeout_Message") : result.errorMessage,
        });
        return false;
    }
};

export const DispatchCompleteLoadOrder: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderStatus/CompleteLoadData",
        result: props.apiResult,
        orderId: props.parameter.orderId,
    });
    if (props.apiResult) {
        if (props.apiParameter?.onSuccess) {
            props.apiParameter?.onSuccess();
        }
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadOrder];

const loadOrder = createHandlerChainRunner(chain, "LoadOrder");
export default loadOrder;
